
<template>
    <div class="headerImgbox">
        <img :src="src?src:require('../images/headerImg.png')" @click="openuserinfo" alt="" class="headerImg">
    </div>
</template>

<script>
import global from "../js/global.js"
export default {
  data () {
    return {
    }
  },
  props:["src",'accountId'],
  created(){
      
  },
  mounted(){
      
  },
  methods:{
    openuserinfo(){
        //打开个人信息页面
        if(global.getmobiletype()=="android"){
            control.toPersonalHomePage(String(this.accountId));
        }
        else{
            window.webkit.messageHandlers.goToUserCenter.postMessage(String(this.accountId));           
        }
    }
  }
}
</script>
<style lang="less" scoped>
.headerImgbox{
    width: .91rem;
    height: .91rem;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    vertical-align: middle;
    float: left;
}
.headerImg{
    max-width: 100%;
    max-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/userinfoimg.vue